import { motion } from "framer-motion";

const chapters = [
  {
    num: "01",
    title: "We don't dictate.",
    copy: "This label is not about telling women what to wear. Trends fade; taste is personal.",
    bg: "bg-[#F3E6E1]",
  },
  {
    num: "02",
    title: "You define.",
    copy: "Her Label exists to help every woman create a label of her own — worn, not prescribed.",
    bg: "bg-[#EAE5F0]",
  },
  {
    num: "03",
    title: "Nails are the beginning.",
    copy: "Press-on couture is our first chapter. A label of her own has many more to come.",
    bg: "bg-[#F3E6E1]",
  },
];

export default function Manifesto() {
  return (
    <section id="manifesto" className="border-y border-[#26221F]/15" data-testid="manifesto-section">
      <div className="px-6 py-24 lg:px-12 lg:py-32">
        <div className="mx-auto max-w-7xl">
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="mb-16 text-xs font-semibold uppercase tracking-[0.4em] text-[#6F665F]"
          >
            The Manifesto
          </motion.p>
          <div className="space-y-8">
            {chapters.map((c, i) => (
              <motion.div
                key={c.num}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
                className={`grid grid-cols-1 items-center gap-8 border border-[#26221F]/15 ${c.bg} p-10 md:grid-cols-12 md:p-16 ${
                  i % 2 === 1 ? "md:ml-24" : "md:mr-24"
                }`}
                data-testid={`manifesto-chapter-${c.num}`}
              >
                <span className="font-display text-8xl italic leading-none text-[#26221F]/15 md:col-span-3 md:text-[10rem]">
                  {c.num}
                </span>
                <div className="md:col-span-9">
                  <h3 className="font-display text-3xl tracking-tight md:text-5xl">{c.title}</h3>
                  <p className="mt-5 max-w-xl text-base leading-relaxed text-[#6F665F] md:text-lg">
                    {c.copy}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
